<template>
    <div>
        <div v-if="loyaltyProgramShort">
            <div
                v-for="(slide, i) in loyaltyProgramShort"
                :key="i"
                class="profile-loyalty-short mx-auto"
                no-gutters
            >
                <NuxtLink to="/profile">
                    <div>
                        <v-img
                            :lazy-src="`${CDN_IMG_URL}/loyalty/${slide.title}.webp`"
                            :src="`${CDN_IMG_URL}/loyalty/${slide.title}.webp`"
                            width="100%"
                            aspect-ratio="2.8"
                            class="mx-auto"
                            :alt="slide.text"
                        ></v-img>
                    </div>

                    <div v-if="name" class="inner-short" :class="slide.color">
                        <div class="font-w letter-space pcard-text f16">
                            Hi {{ name ? name.split(" ")[0] : "" }},
                        </div>
                        <div class="letter-space" :class="titleSize">
                            You are in the
                            <span class="font-w">{{ slide.text }} </span> Tier
                        </div>
                    </div>
                    <!-- <div class="arrow-profile">
                        <v-img
                            :lazy-src="`${CDN_IMG_URL}/loyalty/${slide.arrow}.webp`"
                            :src="`${CDN_IMG_URL}/loyalty/${slide.arrow}.webp`"
                            :width="$breakpoint.xsOnly ? 25 : 25"
                            class="arrow-triple"
                            contain
                            aspect-ratio="1.48"
                            alt="Arrow"
                        >
                        </v-img>
                    </div> -->
                </NuxtLink>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        titleSize: {
            type: String,
            default: "f16",
            required: false
        }
    },
    data() {
        return {
            setUp: process.env.setUp,
            loyaltyProgramShort: [
                {
                    title: "left-blue",
                    color: "white--text",
                    text: "Blue",
                    arrow: "arrow-white"
                }
            ],
            CDN_IMG_URL: process.env.CDN_IMG_URL
        }
    },
    computed: {
        name() {
            return this.$store.state.profile.data.name
        },
        getCategory() {
            return this.$store.state.wallet.userCategory
        }
    },

    mounted() {
        this.getTrunOverDetailsForWallet()
    },
    watch: {
        getCategory() {
            if (this.getCategory && this.getCategory.categoryName) {
                this.imageSearch(this.getCategory.categoryName)
            }
        }
    },
    methods: {
        async getTrunOverDetailsForWallet() {
            if (sessionStorage.getItem("userCategory")) {
                const data = JSON.parse(sessionStorage.getItem("userCategory"))
                this.imageSearch(data.categoryName)
            } else {
                const getData = await this.$store.dispatch(
                    "wallet/getTrunOverDetailsForWallet"
                )
                if (
                    getData &&
                    getData.status === 200 &&
                    getData.data &&
                    getData.data.data
                ) {
                    this.imageSearch(getData.data.data.categoryName)
                }
            }
        },

        imageSearch(categoryName) {
            this.loyaltyProgramShort = []
            if (categoryName === "Blue") {
                this.loyaltyProgramShort = [
                    {
                        title: "left-blue",
                        color: "white--text",
                        text: "Blue",
                        arrow: "arrow-white"
                    }
                ]
            } else if (categoryName === "Silver") {
                this.loyaltyProgramShort = [
                    {
                        title: "left-silver",
                        color: "black--text",
                        text: "Silver",
                        arrow: "arrow-black"
                    }
                ]
            } else if (categoryName === "Gold") {
                this.loyaltyProgramShort = [
                    {
                        title: "left-gold",
                        color: "black--text",
                        text: "Gold",
                        arrow: "arrow-black"
                    }
                ]
            } else if (categoryName === "Platinum") {
                this.loyaltyProgramShort = [
                    {
                        title: "left-platinum",
                        color: "white--text",
                        text: "Platinum",
                        arrow: "arrow-white"
                    }
                ]
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.view-benefits-btn {
    color: $white !important;
    text-decoration: none;
}
.view-benefits-btn .v-icon {
    margin-left: -4px;
    color: $white !important;
}
.view-benefits-btn:hover,
.view-benefits-btn:hover .v-icon {
    color: $black !important;
}
.profile-loyalty-short {
    position: relative;
    .inner-short {
        position: absolute;
        top: 21%;
        left: 4%;
        // font-size: 14px;
        .letter-space {
            letter-spacing: 0.7px;
        }
        .font-w {
            font-weight: 900;
        }
    }
    .arrow-profile {
        position: absolute;
        top: 48%;
        right: 3%;
    }
}
.card-text {
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
